<template>
<div class="container-fluid bg-dark">
	<div class="row">

		<div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0">
			<auction-select></auction-select>
		</div>

		<div class="col text-center py-3 p-0">
			<router-link :to="{path: '/'}">
				<img id="logo"
				     src="/static/img/logo.png" />
			</router-link>
		</div>

		<div class="col-2 py-4 text-right">
			<user-menu class="hidden-xs-down"></user-menu>
		</div>

		<flash-messages-list></flash-messages-list>

	</div>
</div>
</template>

<script>
import AuctionSelect from '@/components/elements/AuctionSelect';
import UserMenu from '@/components/elements/UserMenu';
import FlashMessagesList from '@/components/elements/FlashMessages/FlashMessagesList';

export default {
	components: {
		AuctionSelect,
		UserMenu,
		FlashMessagesList
	},
	data() {
		return {

		}
	}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// AuctionHeader.vue?127d7f48